var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInventoryMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2.75,
    width: 14.5,
    height: 14.5,
    rx: 1.25,
    stroke: "#16191D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58397 8.37596L7.75 9.59861V2.75H12.25V9.59861L10.416 8.37596L10 8.09861L9.58397 8.37596Z",
    stroke: "#16191D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventoryMenu);
export default __webpack_public_path__ + "static/media/icon-inventory-menu.26da2e5c474466928f5455e10f15b011.svg";
export { ForwardRef as ReactComponent };